export interface Prompt {
  id: string
  label: string
  text: string
  category: 'examen' | 'discernment' | 'review'
}

export const PROMPTS: Prompt[] = [
  // Examen
  { id: 'ex1', label: 'Where were you consoled?', text: 'Where did you feel most alive or consoled today? What drained you most?', category: 'examen' },
  { id: 'ex2', label: 'What are you grateful for?', text: 'What — specifically — are you grateful for right now? Have you let it register?', category: 'examen' },
  { id: 'ex3', label: "God's leading today", text: "Where did you sense God's leading today, and did you follow it?", category: 'examen' },
  { id: 'ex4', label: 'What surprised you?', text: 'What surprised you today? What does that surprise reveal about your expectations?', category: 'examen' },
  { id: 'ex5', label: 'Who crossed your path?', text: 'Who crossed your path today, and what was asked of you in that encounter?', category: 'examen' },
  { id: 'ex6', label: 'What do you need to release?', text: 'What are you still carrying from today that needs to be released before tomorrow?', category: 'examen' },
  // Discernment
  { id: 'di1', label: 'Fear or calling?', text: 'Is fear driving this, or calling? What would the decision look like if you removed the fear?', category: 'discernment' },
  { id: 'di2', label: "What is God asking?", text: "Setting aside what others want or expect — what do you sense God asking of you in this season?", category: 'discernment' },
  { id: 'di3', label: 'What would you release?', text: 'If you had to let one thing go this season to protect what matters most, what would it be?', category: 'discernment' },
  { id: 'di4', label: 'Consolation or desolation?', text: 'When you imagine stepping toward this, do you feel consolation or desolation? What does that response tell you?', category: 'discernment' },
  { id: 'di5', label: 'Who speaks truth to you?', text: 'Who in your life speaks truth to you without flattery? What would they say about this decision?', category: 'discernment' },
  // Review
  { id: 'rv1', label: 'Where did time go?', text: 'Where did your time actually go this week — and does that match what you say matters most?', category: 'review' },
  { id: 'rv2', label: 'What needs attention?', text: 'Which of your stated priorities got almost none of your time this week, and what is the honest reason?', category: 'review' },
  { id: 'rv3', label: 'What to say no to?', text: 'What should you say no to this week? What would saying no create space for?', category: 'review' },
  { id: 'rv4', label: 'What shifted?', text: 'What shifted in you this week — in your sense of calling, load, or direction?', category: 'review' },
  { id: 'rv5', label: 'What are you avoiding?', text: 'What are you avoiding, and do you have a good reason — or just a comfortable one?', category: 'review' },
]

const BY_CATEGORY = {
  examen: PROMPTS.filter((p) => p.category === 'examen'),
  discernment: PROMPTS.filter((p) => p.category === 'discernment'),
  review: PROMPTS.filter((p) => p.category === 'review'),
}

const TYPE_TO_CATEGORY: Record<string, keyof typeof BY_CATEGORY> = {
  free: 'examen',
  discernment: 'discernment',
  weekly_review: 'review',
}

export function getPromptsForType(type: string, seedHex: string, count = 3): Prompt[] {
  const category = TYPE_TO_CATEGORY[type] ?? 'examen'
  const pool = BY_CATEGORY[category]
  const offset = parseInt(seedHex.slice(-2), 16) % pool.length
  const rotated = [...pool.slice(offset), ...pool.slice(0, offset)]
  return rotated.slice(0, count)
}
